import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

import {NewNavigationService} from "@shared/services/new-navigation.service";
import {AuthenticationService} from "@shared/services/authentication/authentication.service";

@Component({
  selector: 'authenticationm-handover-login',
  templateUrl: './handover-login.component.html',
})
export class HandoverLoginComponent implements OnInit {

  readonly url = window.location.href;

  token = '';
  isTokenNotValid = false;

  constructor(
    private authenticationService: AuthenticationService,
    private newNavigationService: NewNavigationService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.paramMap.get('token') as string;
    if (this.token)
      this.login();
    else
      this.isTokenNotValid = true;
  }

  private login() {
    this.authenticationService.authenticateByToken(this.token).subscribe({
      next: () => {
        this.newNavigationService.toHandoverView(this.token);
      },
      error: () => {
        this.isTokenNotValid = true;
      }
    });
  }

}
